import {forwardRef, HTMLProps} from "react";
import {useId} from "@floating-ui/react";
import clsx from "clsx";
import {NutritionSummary} from "app/food/NutritionSummary";
import {IFoodFieldsFragment, IUserIngredientFieldsFragment} from "app/gql/graphqlSchema";
import {FoodTag} from "app/food/FoodTag";

interface IFoodItemProps extends HTMLProps<HTMLDivElement> {
  food: IFoodFieldsFragment | IUserIngredientFieldsFragment;
  activeIndex: number | null;
  setActiveIndex: (index: number) => void;
  index: number;
  onSelectFood?: (food: IFoodFieldsFragment | IUserIngredientFieldsFragment) => void;
}

export const FoodItem = forwardRef<HTMLDivElement, IFoodItemProps>(function FoodItemInner(
  {food, activeIndex, onSelectFood, index, setActiveIndex, ...rest},
  ref
) {
  const id = useId();
  const isActive = activeIndex === index;

  const className = clsx(isActive && "bg-gray-200 dark:bg-gray-800 text-grey-900 dark:text-gray-100");
  return (
    <div
      {...rest}
      className={`text-gray-600 dark:text-gray-400 p-2 cursor-pointer flex gap-2 ${className}`}
      id={id}
      onClick={() => {
        return onSelectFood?.(food);
      }}
      onMouseOver={() => setActiveIndex(index)}
      ref={ref}
      title={food.descriptionEn}
    >
      <span>
        {food.nameEn}{" "}
        <span className="text-gray-400 text-xs align-middle">
          <NutritionSummary nutrition={food.nutrition} />, per 100g
        </span>
      </span>
      <span>
        <FoodTag food={food} />
      </span>
    </div>
  );
});
